
	import {bus} from "../autoload/_vue";

	let rotatorInterval;

	export default {
		props: ['tabs'],
		data(){
			return {
				bus,
				tabsFlat: {}
			}
		},
		created(){
			this.addIsActive();
			this.flattenTabs();
		},
		mounted(){
			const slugs = Object.keys(this.tabsFlat);
			const slug = slugs.indexOf(location.hash.substr(2)) !== -1 ? location.hash.substr(2) : false;
			// const slug = slugs.indexOf(location.hash.substr(2)) !== -1 ? location.hash.substr(2) : slugs.shift();
			if(slug) {
				this.loadContent(slug);
			} else {
				if(slugs.length) this.loadContent(slugs[0]);
			}
			this.rotate();
		},
		methods: {
			addIsActive(tabs){
				tabs = tabs || this.tabs;
				for(let slug in tabs){
					tabs[slug].isActive = false;
					tabs[slug].children && this.addIsActive(tabs[slug].children);
				}
			},

			flattenTabs(){
				let tabsFlat = {}, tabs = this.tabs;
				Object.keys(tabs).forEach(key => {
					tabsFlat[key] = Object.assign({}, tabs[key]);

					if(tabs[key].children){
						delete tabsFlat[key].children;
						tabsFlat = Object.assign({}, tabsFlat, tabs[key].children);
					}
				});

				this.tabsFlat = tabsFlat;
			},

			isActiveClass(slug){
				return this.tabsFlat[slug] && this.tabsFlat[slug].isActive ? ' active' : '';
			},
			hasActiveChildClass(slug){
				const children = (this.tabs[slug] && this.tabs[slug].children) || false;

				return children && Object.keys(children).filter(item => this.tabsFlat[item].isActive).length > 0 ? ' has-active-child' : '';
			},
			clickHandler(slug) {
				this.loadContent(slug);
                rotatorInterval && clearInterval(rotatorInterval);
			},
			loadContent(slug){
				Object.keys(this.tabsFlat).map(slug => this.tabsFlat[slug]["isActive"] = false);
				this.tabsFlat[slug]["isActive"] = true;
				const title = this.tabsFlat[slug] && this.tabsFlat[slug].page_title;
				const additional = this.tabsFlat[slug] && this.tabsFlat[slug].additional;
				const content = this.tabsFlat[slug] && this.tabsFlat[slug].content;
				const tables = this.tabsFlat[slug] && this.tabsFlat[slug].tables;
				const slider = this.tabsFlat[slug] && this.tabsFlat[slug].slider;
				bus.$emit('update-content', {title, additional, content, tables, slider});
			},
			rotate() {
			    if(this.tabsFlat && Object.keys(this.tabsFlat).length) {
                    const targetGoalSlugs = Object.keys(this.tabsFlat).filter(slug => slug.indexOf('-goals') !== -1);
                    if(targetGoalSlugs.length) {
                        this.loadContent(targetGoalSlugs[0]);

                        rotatorInterval = setInterval(() => {
                            this.loadContent(targetGoalSlugs[0]);
                            targetGoalSlugs.push(targetGoalSlugs.shift());
                        }, 10000);
					}
				}
			}
		}
	}
